const throttle = require('lodash.throttle');

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const countModule = document.querySelector('.key-callouts-stats');

function checkScroll() {
  // Overlap is the amount the element we want scrolled into the frame.
  // We don't want this to fire if only a few pixels of the module are visible.
  const overlap = 100;
  const inView = countModule.getBoundingClientRect().top - window.innerHeight + overlap <= 0;

  // Debug //

  // console.log({
  //   "window.scrollY": window.scrollY,
  //   "window.innerHeight": window.innerHeight,
  //   "countModule.getBoundingClientRect().top": countModule.getBoundingClientRect().top,
  //   "inView": inView
  // })

  if (inView) {
    window.removeEventListener('scroll', throttleCheckScroll);
    const counters = document.querySelectorAll('.key-callouts-number');
    // const speed = 500;

    counters.forEach( (counter) => {
      const animate = () => {
        const value = +counter.getAttribute('data-count');
        const data = +counter.querySelector('.js-callout').innerText.replace(/,/g, '');
        let step;
        if (+value < 1000) {
            step = 50;
        } else if (+value <= 10000 && +value > 1000) {
            step = 100;
        } else if (+value > 10000) {
            step = 9630000;
        }
        // const time = Math.ceil(value / speed);
        if (data < value) {
          counter.querySelector('.js-callout').innerText = numberWithCommas(data + step); //time
          setTimeout(animate, 200);
        } else {
          counter.querySelector('.js-callout').innerText = numberWithCommas(+value);
        }
      }
      setTimeout(function(){ animate(); }, 200);
    });
  }
}

const throttleCheckScroll = throttle(checkScroll, 50);

if (countModule) {
  // Reset text to zero to prepare for counting up.
  jsCallouts = document.querySelectorAll('.js-callout');
  jsCallouts.forEach((counter) => counter.innerText = "0");

  window.addEventListener('scroll', throttleCheckScroll);

  // Check scroll position on initial load.
  checkScroll();
}
